import React from 'react';
import Button from '@mui/material/Button';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';

type ToggleColor = 'primary' | 'warning' | 'success' | 'secondary' | 'info';

interface ToggleProps {
  label: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  color?: ToggleColor;
}

const Toggle: React.FC<ToggleProps> = ({
  label,
  checked,
  onChange,
  color = 'primary',
}) => (
  <Button
    size="small"
    variant={checked ? 'contained' : 'outlined'}
    color={color}
    onClick={() => onChange(!checked)}
    startIcon={checked ? <ToggleOnIcon /> : <ToggleOffIcon />}
    sx={{
      textTransform: 'none',
      fontSize: 11,
      fontWeight: 600,
      px: 1.5,
      py: 0.5,
      borderRadius: 1.5,
      minWidth: 0,
      ...(!checked && {
        borderColor: '#374151',
        color: '#6b7280',
        '&:hover': { borderColor: '#6b7280' },
      }),
    }}
  >
    {label}
  </Button>
);

export default Toggle;
